import { RelatedItem } from "@newforma/platform-client-api-sdk";

export class RelatedItemMapping {
    static mapToRelatedItemRequest(relatedItems: RelatedItem.RelatedItem[]): RelatedItem.PostRelatedItemsRequest {
        return { items: relatedItems };
    }
}
